import { useRecoilValue } from 'recoil';
import { beaconSelector } from '../recoil/selector';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';
import { useEffect } from 'react';

export const useMtgPurpose = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_PURPOSE,
  });
  const sendBeaconClkBtnOption = ({
    btmsheet_name,
    option_name,
    before_option_name,
  }: IClkBtnOptionProperties) => {
    beacon.sendClkBtnOption({
      properties: <IClkBtnOptionProperties>{
        btmsheet_name: btmsheet_name,
        option_name: option_name,
        before_option_name: before_option_name,
      },
    });
  };
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  return { sendBeaconClkBtnOption };
};
